<script>
	import { Router, Route } from "svelte-routing";
	import MainFuelCardManagement from "./Manage/MainFuelCardManagement.svelte";
	import CreateFuelCardForm from "./CreateFuelCardForm.svelte";
	import EditFuelCard from "./EditFuelCard.svelte";
</script>

<Router url="/">
	<Route path="/" component={MainFuelCardManagement} />
	<Route path="/create" component={CreateFuelCardForm} />
	<Route path="/edit" component={EditFuelCard} />
</Router>
